<template>
    <h1
        :class="
            twMerge(
                'mb-5 whitespace-pre-line text-pretty px-2 text-[1.75rem] font-bold leading-[1.3] sm:px-5 sm:text-[2rem] lg:text-[2.5rem]',
                locale === 'ja' && 'lg:tracking-[-0.03em]',
                locale === 'ko' && 'lg:tracking-[-0.03em]',
            )
        "
    >
        <slot />
    </h1>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { locale } = useI18n();
</script>
